export const user = obj => ({
    type: 'USER',
    obj
})